export default {
  // TODO - REMOVE WHEN WE STOP USING VIDEO CALL V1
  LEAVE_CALL: `Salir de la llamada`,
  OPEN_DEVICE_SETTINGS: `Abrir las configuraciones del equipo`,
  WAITING_ON_PROVIDER: `Esperando por el proveedor`,
  DISABLE_CAMERA: `Desactivar cámara`,
  ENABLE_CAMERA: `Activar cámara`,
  LOADING: `Cargar`,
  UNMUTE_MICROPHONE: `Activar sonido del micrófono.`,
  MUTE_MICROPHONE: `Desactivar sonido del micrófono.`,

  // NEW
  IS_SCREEN_SHARING: 'está compartiendo su pantalla',

  RELATIONSHIP_PATIENT: 'paciente',
  RELATIONSHIP_CAREGIVER: 'cuidador',
  RELATIONSHIP_FAMILY: 'de familia',
  RELATIONSHIP_FRIEND: 'amigo',
  RELATIONSHIP_PROVIDER: 'otro proveedor',
  RELATIONSHIP_INTERPRETER: 'traductor',
  RELATIONSHIP_OTHER: 'otro',

  //Audio only toast
  TOAST_AUDIO_ONLY_HEADER: '¿Cambiar a solo audio?',
  TOAST_AUDIO_ONLY_CONTENT: 'Desactivaremos todas las transmisiones de video para mejorar la calidad de tu llamada.',
  TOAST_AUDIO_ONLY_DISMISS: 'Descartar',
  TOAST_AUDIO_ONLY_YES: 'Sí',

  //Video quality lowered toast
  TOAST_VIDEO_QUALITY_LOWERED_HEADER: `Se redujo la calidad del video`,
  TOAST_VIDEO_QUALITY_LOWERED_CONTENT: `Reducimos la calidad del video para mejorar la experiencia de esta llamada.`,

  //Ambient recording toast - intentionally English-only per UXRD
  AMBIENT_RECORDING_STARTED_TITLE: `Audio recording has started`,
  AMBIENT_RECORDING_STARTED_BODY: `If you'd like to stop the recording, let us know.`,
  AMBIENT_RECORDING_PAUSED_TITLE: `Audio recording has paused`,
  AMBIENT_RECORDING_PAUSED_BODY: `The recording is paused. Your visit continues as normal.`,
  AMBIENT_RECORDING_TOAST_DISMISS: `Dismiss`,

  //Signal quality
  POOR_QUALITY_SIGNAL: `Mala señal de llamada`,
  GOOD_QUALITY_SIGNAL: `Buena señal de llamada`,
  EXCELLENT_QUALITY_SIGNAL: `Excelente señal de llamada`,

  //Auto-reconnect
  RECONNECT_LOADER: `Reconectando la llamada...`,
  RECONNECT_BANNER_LABEL: `Por favor espera`,
  RECONNECT_BANNER_CONTENT: `Intentando conectarte con tu cita.`,
  RECONNECT_ERROR_TITLE: `Error de la red`,
  RECONNECT_ERROR_CONTENT: `Se ha detectado un error de red y no hemos podido reconectar la llamada. Por favor, abandona la llamada y vuelve a conectarte. Si sigues viendo este error, llama al consultorio.`,
  //Title
  VIDEO_CALL_TITLE: `Telehealth - Visita en progreso`,
};
